import React from 'react';
import { View, StyleSheet } from 'react-native-web';
import { withRouter } from 'react-router-dom';

import { Card, Header, ButtonImageWithText  } from "../../../components";
import Colors from "../../../constants/Colors";

const JourneySelectionCard = ( props ) => {

    return (
        <Card containerStyle={{ height: 200, margin: 20, padding: 18 }}>

            <Header
                headerText={"Treinamentos"}
                containerPropsStyle={{ backgroundColor: Colors.cardBackgroundColor }}
                textPropsStyle={{ textAlign: 'center' }}
            />

            <View style={{ flexDirection: 'row' }}>
                <ButtonImageWithText
                    text={"Novos"}
                    onPress={() => props.history.push('/journeys/new')}
                    imageSrc={require('../../../imageImports/journeyNews.png')}
                    propsContainerStyle={styles.buttonContainerStyle}
                    propsImageStyle={styles.imageStyle}
                    propsTextStyle={styles.textStyle}
                    resizeMode={'cover'}
                />

                <ButtonImageWithText
                    text={"Em Progresso"}
                    onPress={() => props.history.push('/journeys/inprogress')}
                    imageSrc={require('../../../imageImports/journeyInProgress.png')}
                    propsContainerStyle={styles.buttonContainerStyle}
                    propsImageStyle={styles.imageStyle}
                    propsTextStyle={styles.textStyle}
                    resizeMode={'cover'}
                />

                <ButtonImageWithText
                    text={"Concluídos"}
                    onPress={() => props.history.push('/journeys/completed')}
                    imageSrc={require('../../../imageImports/journeyComplete.png')}
                    propsContainerStyle={styles.buttonContainerStyle}
                    propsImageStyle={styles.imageStyle}
                    propsTextStyle={styles.textStyle}
                    resizeMode={'cover'}
                />
            </View>
        </Card>
    )

}

const styles = StyleSheet.create({
    buttonContainerStyle: {
        height: 120,
        width: '28%',
        flexDirection: 'column',
        backgroundColor: Colors.cardButtonBackground,
        borderRadius: 8,
        margin: 8
    },
    imageStyle: {
        // backgroundColor: 'black',
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0,
        width: '100%',
        height: '66%',
    },
    textStyle: {
        color: Colors.cardButtonFontColor,
        fontSize: 14
    }
})

export default withRouter(JourneySelectionCard);
